export enum UserStatus {
    ACTIVE = 'active',
    AWAY = 'away',
    OFFLINE = 'offline',
    ARCHIVE = 'archive'
}

export const USER_STATUS_LABELS: Record<UserStatus, string> = {
    [UserStatus.ACTIVE]: 'Active',
    [UserStatus.AWAY]: 'Away',
    [UserStatus.OFFLINE]: 'Offline',
    [UserStatus.ARCHIVE]: 'Archive'
};
